import { render } from "./procedures.vue?vue&type=template&id=5d658d8a&scoped=true"
import script from "./procedures.vue?vue&type=script&lang=js"
export * from "./procedures.vue?vue&type=script&lang=js"

import "./procedures.vue?vue&type=style&index=0&id=5d658d8a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d658d8a"]])

export default __exports__